import { render, staticRenderFns } from "./Uploadfile.vue?vue&type=template&id=7bbe38b9"
import script from "./Uploadfile.vue?vue&type=script&lang=js"
export * from "./Uploadfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports